import script from "./StoryViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./StoryViewer.vue?vue&type=script&setup=true&lang=js"

import "./StoryViewer.vue?vue&type=style&index=0&id=60d3d642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d3d642"]])

export default __exports__